import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import Assets from 'app/configs/assetConfigs'

const useStyles = makeStyles((theme) => ({
  notificationPDFContainer: {
    height: '98px',
    minWidth: '100%',
    backgroundColor: '#f7f7f7',
  },
  notificationPDF: {
    backgroundColor: theme.palette.background.paleSkyBlue,
    borderRadius: '10px',
  },
}))

export default (props) => {
  const classes = useStyles()
  const { fileName, fileSize, onClick } = props
  return (
    <div
      className={clsx(
        'flex flex-row sm:px-32 px-16 py-16 ',
        classes.notificationPDFContainer,
      )}
    >
      <div
        className={clsx(
          'w-full h-full flex flex-row p-16 cursor-pointer items-center',
          classes.notificationPDF,
        )}
        onClick={onClick}
      >
        <img
          alt="pdf"
          src={Assets.notificationCard.pdfIcon}
          className="h-36 sm:h-32 w-auto"
        />
        <div className="flex flex-col w-5/6 px-16">
          <Typography className="truncate max-w-sm min-h-20" color="primary">
            {fileName && fileName.length > 0 ? (
              fileName
            ) : (
              <FormattedMessage id="pdfMediaSection.fileName.placeholder" />
            )}
          </Typography>
          {fileSize ? <Typography>{fileSize}</Typography> : null}
        </div>
      </div>
    </div>
  )
}
